import React from 'react';
import LegalNoticeES from './legalNoticeES';
import LegalNoticeEN from './legalNoticeEN';
import LegalNoticeCA from './legalNoticeCA';
import { useParams } from 'react-router-dom';

const LegalNotice: React.FC = () => {
    const { lang } = useParams<{ lang?: string }>();
    const storedLang = localStorage.getItem('language');
    const language = lang || storedLang || 'es';

    if (language === 'es') {
        return (
            <LegalNoticeES />
        );
    } else if (language === 'en') {
        return (
            <LegalNoticeEN />
        );
    } else if (language === 'ca') {
        return (
            <LegalNoticeCA />
        );
    } else {
        return (
            <LegalNoticeES />
        );
    }
};

export default LegalNotice;
